import { Box, Card, CardContent, Divider, Typography } from '@mui/material';

import { url } from '../../appRouter/url';
import { EasyBreadcrumbs, type EasyBreadcrumbsItem } from '../../components/general';
import { usePageTitle } from '../../hooks/usePageTitle';
import { RaumRessourcenOverviewCalendar } from './RaumRessourcenOverviewCalendar';

export const RaumRessourcenOverviewPage = () => {
  usePageTitle('Raum-Ressourcen-Übersicht');
  const breadcrumbs: EasyBreadcrumbsItem[] = [
    {
      href: url.root(),
      label: 'Dashboard',
    },
    {
      href: '',
      label: 'Raum-Ressourcen-Übersicht',
    },
  ];

  return (
    <Box mt={2}>
      <EasyBreadcrumbs items={breadcrumbs} />
      <Card sx={{ border: 0 }}>
        <CardContent>
          <Typography variant="headingXs">Raum-Ressourcen-Übersicht</Typography>
          <Divider />
          <RaumRessourcenOverviewCalendar />
        </CardContent>
      </Card>
    </Box>
  );
};
